import { Api } from "../config/request";

export default {
    generateQR(queryParams) {
        return Api.post(`/qr-dashboard/generate-qr`, queryParams);
    },
    fetchVendors(queryParams) {
        return Api.get(
            `/qr-dashboard/active-vendors?${queryParams}`
        );
    }
};